export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/vip.71ff64f0-ece364.png";